const spices = [
  {
    id: "Chilli Powder", 
    name: "Chilli Powder", 
    nameKey: "chilli_powder",
    image: require("../assets/chillipowder.jpg"),
    originKey: "india", // Use key for origin
    typeKey: "ground_spice", // Use key for type
    descriptionKey: "chilli_powder_description",
    subDescriptionKey: "chilli_powder_sub_description"
  },
  {
    id: "Turmeric Powder",
    name: "Turmeric Powder",
    nameKey: "turmeric_powder",
    image: require("../assets/turmeric powder.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "turmeric_powder_detail_description", // Specific key for detail page
    subDescriptionKey: "turmeric_powder_detail_sub_description" // Specific key for detail page
  },
  {
    id: "Coriander Powder",
    name: "Coriander Powder",
    nameKey: "coriander_powder",
    image: require("../assets/coriander ground.jpg"),
    originKey: "india",
    typeKey: "ground_seed_spice",
    descriptionKey: "coriander_powder_description",
    subDescriptionKey: "coriander_powder_sub_description"
  },
  {
    id: "Green Cardamom",
    name: "Green Cardamom",
    nameKey: "green_cardamom",
    image: require("../assets/green cardamom.jpg"),
    originKey: "india",
    typeKey: "whole_spice_pods",
    descriptionKey: "green_cardamom_description",
    subDescriptionKey: "green_cardamom_sub_description"
  },
  {
    id: "Clove",
    name: "Clove",
    nameKey: "clove",
    image: require("../assets/cloves.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "clove_description",
    subDescriptionKey: "clove_sub_description"
  },
  {
    id: "Black Pepper",
    name: "Black Pepper",
    nameKey: "black_pepper",
    image: require("../assets/blackpepper.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "black_pepper_description",
    subDescriptionKey: "black_pepper_sub_description"
  },
  {
    id: "Cumin Seeds",
    name: "Cumin Seeds",
    nameKey: "cumin_seeds",
    image: require("../assets/cumin.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "cumin_seeds_description",
    subDescriptionKey: "cumin_seeds_sub_description"
  },
  {
    id: "Fennel Seeds",
    name: "Fennel Seeds",
    nameKey: "fennel_seeds",
    image: require("../assets/fennel.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "fennel_seeds_description",
    subDescriptionKey: "fennel_seeds_sub_description"
  },
  {
    id: "Fenugreek Seeds",
    name: "Fenugreek Seeds",
    nameKey: "fenugreek_seeds",
    image: require("../assets/fenugreek.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "fenugreek_seeds_description",
    subDescriptionKey: "fenugreek_seeds_sub_description"
  },
  {
    id: "Cinnamon",
    name: "Cinnamon",
    nameKey: "cinnamon",
    image: require("../assets/cinnamon stick.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "cinnamon_description",
    subDescriptionKey: "cinnamon_sub_description"
  },
  {
    id: "Bay Leaves",
    name: "Bay Leaves",
    nameKey: "bay_leaves",
    image: require("../assets/bayleaves.jpeg"),
    originKey: "india",
    typeKey: "whole_leaf_spice",
    descriptionKey: "bay_leaves_description",
    subDescriptionKey: "bay_leaves_sub_description"
  },
  {
    id: "Fennel Seeds Powder",
    name: "Fennel Seeds Powder",
    nameKey: "fennel_seeds_powder",
    image: require("../assets/fennel ground.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "fennel_seeds_powder_description",
    subDescriptionKey: "fennel_seeds_powder_sub_description"
  },
  {
    id: "Cumin Powder",
    name: "Cumin Powder",
    nameKey: "cumin_powder",
    image: require("../assets/cumin powder.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "cumin_powder_description",
    subDescriptionKey: "cumin_powder_sub_description"
  },
  {
    id: "Whole Coriander",
    name: "Whole Coriander",
    nameKey: "whole_coriander",
    image: require("../assets/coriander whole.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "whole_coriander_description",
    subDescriptionKey: "whole_coriander_sub_description"
  },
  {
    id: "Nigella Seeds",
    name: "Nigella Seeds",
    nameKey: "nigella_seeds",
    image: require("../assets/spices/nigella.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "nigella_seeds_description",
    subDescriptionKey: "nigella_seeds_sub_description"
  },
  {
    id: "Caraway Seeds (Black)",
    name: "Caraway Seeds (Black)",
    nameKey: "caraway_seeds",
    image: require("../assets/spices/caraway seeds.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "caraway_seeds_description",
    subDescriptionKey: "caraway_seeds_sub_description"
  },
    {
    id: "Ground Fenugreek",
    name: "Ground Fenugreek",
    nameKey: "ground_fenugreek",
    image: require("../assets/spices/groundfenugreek.jpeg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_fenugreek_description",
    subDescriptionKey: "ground_fenugreek_sub_description"
  },{
     id: "Ground Green Cardamom",
    name: "Ground Green Cardamom",
    nameKey: "ground_green_cardamom",
    image: require("../assets/spices/cardamom ground.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_green_cardamom_description",
    subDescriptionKey: "ground_green_cardamom_sub_description"
  },
  {
    id: "Whole Ginger",
    name: "Whole Ginger",
    nameKey: "whole_ginger",
    image: require("../assets/spices/wholeginger.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "whole_ginger_description",
    subDescriptionKey: "whole_ginger_sub_description"
  },
  {   id: "Ground Ginger",
    name: "Ground Ginger",
    nameKey: "ground_ginger",
    image: require("../assets/spices/ground ginger.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_ginger_description",
    subDescriptionKey: "ground_ginger_sub_description"
  },
  {   id: "Ground Clove",
    name: "Ground Clove",
    nameKey: "ground_clove",
    image: require("../assets/spices/clove powder.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_clove_description",
    subDescriptionKey: "ground_clove_sub_description"
  },
    {   id: "Ground Cinnamon",
    name: "Ground Cinnamon",
    nameKey: "ground_cinnamon",
    image: require("../assets/spices/cinnamon ground.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_cinnamon_description",
    subDescriptionKey: "ground_cinnamon_sub_description"
  },
  {   id: "Ground Nutmeg",
    name: "Ground Nutmeg",
    nameKey: "ground_nutmeg",
    image: require("../assets/spices/ground_nutmeg.jpeg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_nutmeg_description",
    subDescriptionKey: "ground_nutmeg_sub_description"
  },
   {   id: "Nutmeg",
    name: "Nutmeg",
    nameKey: "nutmeg",
    image: require("../assets/spices/nutmeg1.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "nutmeg_description",
    subDescriptionKey: "nutmeg_sub_description"
  },
  {   id: "Ground Mace",
    name: "Ground Mace",
    nameKey: "ground_mace",
    image: require("../assets/spices/ground mace.jpeg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_mace_description",
    subDescriptionKey: "ground_mace_sub_description"
  },
  {   id: "Black Sesame",
    name: "Black Sesame",
    nameKey: "black_sesame",
    image: require("../assets/spices/black sesame.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "black_sesame_description",
    subDescriptionKey: "black_sesame_sub_description"
  },
   {   id: "White Sesame",
    name: "White Sesame",
    nameKey: "white_sesame",
    image: require("../assets/spices/white sesame.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "white_sesame_description",
    subDescriptionKey: "white_sesame_sub_description"
  },
     {   id: "Whole Hot Chilli",
    name: "Whole Hot Chili",
    nameKey: "whole_hot_chili",
    image: require("../assets/spices/whole chilli.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "whole_hot_chilli_description",
    subDescriptionKey: "whole_hot_chilli_sub_description"
  },
  {   id: "Chilli Flakes",
    name: "Chilli Flakes",
    nameKey: "chilli_flakes",
    image: require("../assets/spices/crushed chilli.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "chilli_flakes_description",
    subDescriptionKey: "chilli_flakes_sub_description"
  },
    {   id: "Anise Seeds",
    name: "Anise Seeds",
    nameKey: "anise_seeds",
    image: require("../assets/spices/anise seeds.webp"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "anise_seeds_description",
    subDescriptionKey: "anise_seeds_sub_description"
  },
  {   id: "Ground Anise",
    name: "Ground Anise",
    nameKey: "ground_anise",
    image: require("../assets/spices/ground anise.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "ground_anise_description",
    subDescriptionKey: "ground_anise_sub_description"
  },
  {   id: "Star Anise (Whole)",
    name: "Star Anise (Whole)",
    nameKey: "star_anise",
    image: require("../assets/spices/star anise 2.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "star_anise_description",
    subDescriptionKey: "star_anise_sub_description"
  },
  {   id: "Brown Mustard Seeds",
    name: "Brown Mustard Seeds",
    nameKey: "brown_mustard_seeds",
    image: require("../assets/spices/brownmustardseeds.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "brown_mustard_description",
    subDescriptionKey: "brown_mustard_sub_description"
  },
  {   id: "Yellow Mustard Seeds",
    name: "Yellow Mustard Seeds",
    nameKey: "yellow_mustard_seeds",
    image: require("../assets/spices/yellow seed mustard.webp"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "yellow_mustard_description",
    subDescriptionKey: "yellow_mustard_sub_description"
  },
  {   id: "Linseeds (Flaxseed)",
    name: "Linseeds (Flaxseed)",
    nameKey: "linseeds",
    image: require("../assets/spices/linseed.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "linseeds_description",
    subDescriptionKey: "linseeds_sub_description"
  },
  {   id: "Chia Seeds",
    name: "Chia Seeds",
    nameKey: "chia_seeds",
    image: require("../assets/spices/chiaseeds.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "chia_seeds_description",
    subDescriptionKey: "chia_seeds_sub_description"
  },
  {   id: "Garlic Granules",
    name: "Garlic Granules",
    nameKey: "garlic_granules",
    image: require("../assets/spices/garlic granules.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "garlic_granules_description",
    subDescriptionKey: "garlic_granules_sub_description"
  },
   {   id: "Grilled and Sliced Onion",
    name: "Grilled and Sliced Onion",
    nameKey: "grilled_sliced_onion",
    image: require("../assets/spices/grilled onion.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "grilled_sliced_onion_description",
    subDescriptionKey: "grilled_sliced_onion_sub_description"
  },
  {   id: "Crushed Black Pepper",
    name: "Crushed Black Pepper",
    nameKey: "crushed_black_pepper",
    image: require("../assets/spices/crushed black pepper.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "crushed_black_pepper_description",
    subDescriptionKey: "crushed_blacked_pepper_sub_description"
  },
   {   id: "Powdered Black Pepper",
    name: "Powdered Black Pepper",
    nameKey: "powdered_black_pepper",
    image: require("../assets/spices/powdered black pepper.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "powdered_black_pepper_description",
    subDescriptionKey: "powdered_black_pepper_sub_description"
  },
  {   id: "Crushed White Pepper",
    name: "Crushed White Pepper",
    nameKey: "crushed_white_pepper",
    image: require("../assets/spices/crushed white pepper.jpeg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "crushed_white_pepper_description",
    subDescriptionKey: "crushed_white_pepper_sub_description"
  },
  {   id: "Powdered White Pepper",
    name: "Powdered White Pepper",
    nameKey: "powdered_white_pepper",
    image: require("../assets/spices/powdered white pepper.jpg"),
    originKey: "india",
    typeKey: "ground_spice",
    descriptionKey: "powdered_white_pepper_description",
    subDescriptionKey: "powdered_white_pepper_sub_description"
  },
  {   id: "Whole White Pepper",
    name: "Whole White Pepper",
    nameKey: "whole_white_pepper",
    image: require("../assets/spices/whole white pepper.jpg"),
    originKey: "india",
    typeKey: "whole_spice",
    descriptionKey: "whole_white_pepper_description",
    subDescriptionKey: "whole_white_pepper_sub_description"
  },

  // herbs
  {   id: "Mint Leaves",
    name: "Mint Leaves",
    nameKey: "mint_leaves",
    image: require("../assets/herbs/mint.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "mint_leaves_description",
    subDescriptionKey: "mint_leaves_sub_description"
  },
  {   id: "Basil",
    name: "Basil",
    nameKey: "basil",
    image: require("../assets/herbs/basil.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "basil_description",
    subDescriptionKey: "basil_sub_description"
  },
  {   id: "Oregano",
    name: "Oregano",
    nameKey: "oregano",
    image: require("../assets/herbs/oregano.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "oregano_description",
    subDescriptionKey: "oregano_sub_description"
  },
  {   id: "Thyme",
    name: "Thyme",
    nameKey: "thyme",
    image: require("../assets/herbs/thyme.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "thyme_description",
    subDescriptionKey: "thyme_sub_description"
  },
  {   id: "Rosemary Leaves",
    name: "Rosemary Leaves",
    nameKey: "rosemary_leaves",
    image: require("../assets/herbs/rosemary(1).jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "rosemary_leaves_description",
    subDescriptionKey: "rosemary_leaves_sub_description"
  },
  {   id: "Coriander Leaves (Dried)",
    name: "Coriander Leaves (Dried)",
    nameKey: "coriander_leaves",
    image: require("../assets/herbs/coriander.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "coriander_leaves_description",
    subDescriptionKey: "coriander_leaves_sub_description"
  },
  {   id: "Rose (Dried Petals)",
    name: "Rose (Dried Petals)",
    nameKey: "rose",
    image: require("../assets/herbs/dried rose petals.jpg"),
    originKey: "india",
    typeKey: "herbs",
    descriptionKey: "rose_description",
    subDescriptionKey: "rose_sub_description"
  },

  // pickles
  {   id: "Mango Pickle",
    name: "Mango Pickle",
    nameKey: "mango",
    image: require("../assets/pickle/mangowhole.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "mango_description",
    subDescriptionKey: "mango_sub_description"
  },
  {   id: "Cut Mango Pickle",
    name: "Cut Mango Pickle",
    nameKey: "cut_mango",
    image: require("../assets/pickle/mango-pickle.jpg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "cut_mango_description",
    subDescriptionKey: "cut_mango_sub_description"
  },
  {   id: "Lemon Pickle",
    name: "Lemon Pickle",
    nameKey: "lemon",
    image: require("../assets/pickle/lemonpickle.jpg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "lemon_description",
    subDescriptionKey: "lemon_sub_description"
  },
  {   id: "Garlic Pickle",
    name: "Garlic Pickle",
    nameKey: "garlic_pickle",
    image: require("../assets/pickle/garlicpickle.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "garlic_pickle_description",
    subDescriptionKey: "garlic_pickle_sub_description"
  },
  {   id: "Gooseberry Pickle (Amla Pickle)",
    name: "Gooseberry Pickle (Amla Pickle)",
    nameKey: "gooseberry_pickle",
    image: require("../assets/pickle/gooseberry.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "gooseberry_description",
    subDescriptionKey: "gooseberry_sub_description"
  },
  {   id: "Mixed Pickle",
    name: "Mixed Pickle",
    nameKey: "mixed",
    image: require("../assets/pickle/mixed.jpg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "mixed_description",
    subDescriptionKey: "mixed_sub_description"
  },
  {   id: "Dates Pickle",
    name: "Dates Pickle",
    nameKey: "dates",
    image: require("../assets/pickle/dates pickle.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "dates_description",
    subDescriptionKey: "dates_sub_description"
  },
  {   id: "Fish Pickle",
    name: "Fish Pickle",
    nameKey: "fish",
    image: require("../assets/pickle/fishpickle.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "fish_description",
    subDescriptionKey: "fish_sub_description"
  },
  {   id: "Prawns Pickle",
    name: "Prawns Pickle",
    nameKey: "prawns",
    image: require("../assets/pickle/prawns.jpeg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "prwans_description",
    subDescriptionKey: "prawns_sub_description"
  },
    {   id: "Ginger Pickle",
    name: "Ginger Pickle",
    nameKey: "ginger_pickle",
    image: require("../assets/pickle/gingerpickle.webp"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "ginger_pickle_description",
    subDescriptionKey: "ginger_pickle_sub_description"
  },
    {   id: "Chilli Pickle",
    name: "Chilli Pickle",
    nameKey: "chilli_pickle",
    image: require("../assets/pickle/chillipickle.jpg"),
    originKey: "india",
    typeKey: "pickle",
    descriptionKey: "chilli_pickle_description",
    subDescriptionKey: "chilli_pickle_sub_description"
  },
];
export default spices;